export default __webpack_public_path__ + "static/media/favorite.2f2af92e.svg";